module.exports = __webpack_public_path__ + "static/media/IFFCOTokioGeneralInsurance.23101287.png";